// src/services/partenairesPhotoServices.js
import axios from "axios";

// Compat Vite & CRA
const _base =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  "";

const baseUrl = _base.replace(/\/$/, "");
const apiUrl = `${baseUrl}/api/partenaires`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Helper: URL absolue pour <img src=...>
 * - Si /uploads/... => préfixe par baseUrl
 * - Sinon renvoie tel quel (ex: Cloudinary https://...)
 */
export const toAbsolutePhotoUrl = (photoUrl) => {
  if (!photoUrl) return "";
  if (photoUrl.startsWith("/uploads/")) return `${baseUrl}${photoUrl}`;
  return photoUrl;
};

/** (optionnel) pour forcer refresh cache après upload */
export const withBust = (url, v) =>
  url ? `${url}${url.includes("?") ? "&" : "?"}v=${v}` : url;

/* =========================
   Upload Partenaires (3 photos)
   ========================= */

/**
 * Upload Photo 1
 * Back route: PATCH /api/partenaires/:id/updatePhoto1
 * Champ multipart: "partenairePhoto1"
 */
export const uploadPartenairePhoto1 = async (partenaireId, file, options = {}) => {
  if (!partenaireId) throw new Error("partenaireId requis");
  if (!file) throw new Error("file requis");

  const { format = "webp", onUploadProgress } = options;

  const form = new FormData();
  form.append("partenairePhoto1", file); // ⚠️ doit matcher routes: single("partenairePhoto1")

  const qs = format ? `?format=${encodeURIComponent(format)}` : "";

  try {
    const { data } = await axios.patch(
      `${apiUrl}/${encodeURIComponent(partenaireId)}/updatePhoto1${qs}`,
      form,
      {
        headers: { ...authHeaders() },
        onUploadProgress,
      },
    );
    return data;
  } catch (error) {
    console.error("[uploadPartenairePhoto1] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Upload Photo 2
 * Back route: PATCH /api/partenaires/:id/updatePhoto2
 * Champ multipart: "partenairePhoto2"
 */
export const uploadPartenairePhoto2 = async (partenaireId, file, options = {}) => {
  if (!partenaireId) throw new Error("partenaireId requis");
  if (!file) throw new Error("file requis");

  const { format = "webp", onUploadProgress } = options;

  const form = new FormData();
  form.append("partenairePhoto2", file); // ⚠️ single("partenairePhoto2")

  const qs = format ? `?format=${encodeURIComponent(format)}` : "";

  try {
    const { data } = await axios.patch(
      `${apiUrl}/${encodeURIComponent(partenaireId)}/updatePhoto2${qs}`,
      form,
      {
        headers: { ...authHeaders() },
        onUploadProgress,
      },
    );
    return data;
  } catch (error) {
    console.error("[uploadPartenairePhoto2] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Upload Photo 3
 * Back route: PATCH /api/partenaires/:id/updatePhoto3
 * Champ multipart: "partenairePhoto3"
 */
export const uploadPartenairePhoto3 = async (partenaireId, file, options = {}) => {
  if (!partenaireId) throw new Error("partenaireId requis");
  if (!file) throw new Error("file requis");

  const { format = "webp", onUploadProgress } = options;

  const form = new FormData();
  form.append("partenairePhoto3", file); // ⚠️ single("partenairePhoto3")

  const qs = format ? `?format=${encodeURIComponent(format)}` : "";

  try {
    const { data } = await axios.patch(
      `${apiUrl}/${encodeURIComponent(partenaireId)}/updatePhoto3${qs}`,
      form,
      {
        headers: { ...authHeaders() },
        onUploadProgress,
      },
    );
    return data;
  } catch (error) {
    console.error("[uploadPartenairePhoto3] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};
